<mat-dialog-content>
    <div *ngIf="title" class="title" [innerHTML]="title"></div>
    <div [innerHTML]="message"></div>
</mat-dialog-content>